module.exports = __webpack_public_path__ + "img/car.694401df.jpg";